var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.5L3.5 7L4.2 6.275L5.5 7.575V3.5H6.5V7.575L7.8 6.275L8.5 7L6 9.5ZM3 11.5C2.725 11.5 2.48958 11.4021 2.29375 11.2063C2.09792 11.0104 2 10.775 2 10.5V9H3V10.5H9V9H10V10.5C10 10.775 9.90208 11.0104 9.70625 11.2063C9.51042 11.4021 9.275 11.5 9 11.5H3Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.83fea2edb593e762429afb19d450fafa.svg";
export { ForwardRef as ReactComponent };